import { render } from "./BetRecord.vue?vue&type=template&id=3c61da46&scoped=true"
import script from "./BetRecord.vue?vue&type=script&lang=js"
export * from "./BetRecord.vue?vue&type=script&lang=js"

import "./BetRecord.vue?vue&type=style&index=0&id=3c61da46&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c61da46"]])

export default __exports__